<!--
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
-->

<template>
  <component :is="fieldWrapper" v-bind="{ description, id, required, title }">
    <div class="input-group">
      <template v-if="value">
        <span class="input-group-btn">
          <b-button class="clear-uploaded" variant="danger" @click="clearUpload">
            <i class="fa fa-trash" />
          </b-button>
        </span>
        <input :value="value" :required="required" type="text" class="form-control" readonly />
      </template>
      <div v-else-if="uploading" class="form-control">
        <div class="progress">
          <div :style="{ width: `${uploadProgress}%` }" class="progress-bar" />
        </div>
      </div>
      <input
        v-else
        :id="id"
        :class="['form-control file-input', validationClass]"
        :required="required"
        type="file"
        @change="selectFile"
      />
    </div>
  </component>
</template>

<script>
import $ from 'jquery';
import { BButton } from 'bootstrap-vue';

import { common } from './_mixins';

export default {
  name: 'File',
  components: {
    BButton,
  },
  mixins: [common],
  inject: ['csrfToken', 'apiUploadFileUrl', 'apiDeleteFileUrl'],
  data() {
    return {
      uploading: false,
      uploadProgress: 0,
      type: 'url',
    };
  },
  methods: {
    selectFile(event) {
      this.$emit('toggleUpload', true);
      this.uploading = true;
      this.$nextTick(() => {
        this.uploadProgress = 100;
      });
      const file = event.target.files[0];
      const url = this.apiUploadFileUrl.replace(':question_id:', this.id);
      const form = new FormData();
      form.append('file', file);
      this.uploadFile(url, form);
    },
    clearUploadInput() {
      this.uploadProgress = 0;
      this.$emit('toggleUpload', false);
      this.uploading = false;
      this.$emit('input', null);
      this.deleting = false;
    },
    clearUpload() {
      if (this.deleting) {
        return;
      }
      if (this.value === null) {
        this.clearUploadInput();
        return;
      }
      this.deleting = true;
      const url = this.apiDeleteFileUrl.replace(':question_id:', this.id);
      $.ajax(url, {
        method: 'DELETE',
        headers: { 'X-CSRF-Token': this.csrfToken },
        success: this.clearUploadInput,
        error() {
          window.GGRC.Notify({
            type: 'error',
            message: 'An error has occurred',
          });
        },
      });
    },
    uploadFile(url, form) {
      $.ajax(url, {
        method: 'POST',
        headers: { 'X-CSRF-Token': this.csrfToken },
        processData: false,
        contentType: false,
        data: form,
        success: res => {
          this.$emit('toggleUpload', false);
          this.uploading = false;
          this.$emit('input', res.name);
          this.uploadProgress = 0;
        },
        error: this.handleError,
      });
    },
    handleError(jqXHR) {
      const DEFAULT_ERROR = 'An error has occurred';
      const errors = {
        '0': DEFAULT_ERROR,
        '404': 'Question no longer exists.',
        '413': 'File is too large to upload. File size limit is 50MB.',
        '422': DEFAULT_ERROR,
        '500': DEFAULT_ERROR,
      };
      window.GGRC.Notify({
        type: 'error',
        message: errors[jqXHR.status],
      });
      this.clearUploadInput();
    },
  },
};
</script>

<style lang="scss" scoped>
/* stylelint-disable-next-line selector-max-type */
label {
  display: block;
}

.progress {
  height: 17px;
  width: 100%;
  .progress-bar {
    transition: width 1.5s ease-in-out;
  }
}

.clear-uploaded {
  padding-top: 0.6rem;
  padding-bottom: 0.6rem;
}

// Hack to get the node rendered properly in Ms Edge
@supports (-ms-ime-align: auto) {
  .file-input {
    min-height: 2.5rem;
  }
}
</style>
